import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import { useDispatch, useSelector } from "react-redux";
import { setSendRegistrationMailVisible } from "../Slice/DialogSlice";
import { AppDispatch, RootState } from "../Store";
import { useSendVerifyEmailAgainMutation } from "../api/LoginAPI";


export default function AuthDialogSendRegistrationMail() {

    const sendRegistrationMailVisible = useSelector((state: RootState) => state.authReducer.dialog.sendRegistrationMailVisible);
    const newProfile = useSelector((state: RootState) => state.authReducer.authCreate.profile);
    const [sendRegistrationMailAgain, {isSuccess, isError}] = useSendVerifyEmailAgainMutation();
    const dispatch = useDispatch<AppDispatch>();

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <div className="font-bold white-space-nowrap">Login</div>
            <div>
                <h3>We have sent you a registration email.</h3>
            </div>
        </div>
    );

    const footerContent = (
        <div>
            <Button 
                label="SEND AGAIN" 
                onClick={() => {
                    sendRegistrationMailAgain(newProfile.email);
                }} />
        </div>
    );

    return (
        <Dialog 
            header={headerElement} 
            footer={footerContent} 
            visible={sendRegistrationMailVisible} 
            style={{ width: '50vw' }} 
            onHide={() => dispatch(setSendRegistrationMailVisible(false))}
        >
             <i className={classNames("pi pi-envelope") } style={{ fontSize: '2.5rem' }}></i>
             <p>
                Please confirm the email to complete the registration. 
                <br/>
                The email was sent to: 
                <br/>
                {newProfile.email} 
                <br/><br/>
                Did not receive the email? Check your spam filter.
             </p>
        </Dialog>
    )
}